

import { ENDPOINTS, requestType } from "../constants/Variables";
import Api from "./index";

const createDiscountRule = (_, params) => {
    const url = ENDPOINTS.DISCOUNT_RULES.CREATE;

    return Api(url, params, requestType.POST);
};

const updateDiscountRule = (id, params) => {
    const url = ENDPOINTS.DISCOUNT_RULES.UPDATE.replace(":id", id);

    return Api(url, params, requestType.PUT);
};

const getAllDiscountRules = (params) => {

    const url = ENDPOINTS.DISCOUNT_RULES.GET_ALL;

    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append("search", params.search);
    if (params?.startDate) queryParams.append("startDate", params.startDate);
    if (params?.endDate) queryParams.append("endDate", params.endDate);
    if (params?.status) queryParams.append("status", params.status);
    if (params?.page) queryParams.append("page", params.page);
    if (params?.limit) queryParams.append("limit", params.limit);

    const finalUrl = queryParams.toString() ?
        `${url}?${queryParams.toString()}`
        : `${url}`;

    return Api(finalUrl, null, requestType.GET);
};

const getDiscountRuleById = (id) => {
    const url = ENDPOINTS.DISCOUNT_RULES.GET_SINGLE.replace(":id", id);

    return Api(url, null, requestType.GET);
};

const getMatchingDiscountRule = (params) => {
    const url = ENDPOINTS.DISCOUNT_RULES.GET_MATCHING_DISCOUNT_RULE;
    const queryParams = new URLSearchParams();
    queryParams.append("amount", params.amount);
    const finalUrl = queryParams.toString() ? `${url}?${queryParams}` : url;

    return Api(finalUrl, null, requestType.GET);
};

const getActiveDiscountRules = () => {
    const url = ENDPOINTS.DISCOUNT_RULES.ACTIVE_DISCOUNT_RULES;
    const queryParams = new URLSearchParams();
    queryParams.append("active", true);
    const finalUrl = queryParams.toString() ? `${url}?${queryParams}` : url;
    return Api(finalUrl, null, requestType.GET);
};

export {
    createDiscountRule,
    updateDiscountRule,
    getAllDiscountRules,
    getDiscountRuleById,
    getMatchingDiscountRule,
    getActiveDiscountRules,
};
